import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'app/environments/environment';
import { enableProdMode } from '@angular/core';
import { registerLicense } from '@syncfusion/ej2-base';


registerLicense('Ngo9BigBOggjGyl/VkR+XU9Ff1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTd0dnWH5acndWQmhcU091XQ==');

if (environment.production) 
{
    enableProdMode();
}


bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
